import { render, staticRenderFns } from "./BaseModalConfirm2.vue?vue&type=template&id=74962531&scoped=true&"
import script from "./BaseModalConfirm2.vue?vue&type=script&lang=js&"
export * from "./BaseModalConfirm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74962531",
  null
  
)

export default component.exports